module.exports = __webpack_public_path__ + "static/img/02_love.88a9544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/02_love.png
// module id = Kn9p
// module chunks = 158